import { useState } from "react";
import { timelineCases, type TimelineCase } from "@/mocks/guaData";

export default function TimelineSection() {
  const [active, setActive] = useState<TimelineCase>(timelineCases[0]);

  return (
    <section id="timeline" className="scroll-mt-24 w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-semibold text-accent-800">
            <i className="ri-time-line"></i> 事件时间线复盘
          </span>
          <h2 className="font-heading mt-5 text-3xl md:text-4xl font-bold text-foreground-950">来龙去脉，按时间线讲清</h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            每场事件都被整理成一条可回溯的时间线，标注关键节点与各方发声。点开档案，前因后果一目了然。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-4 flex flex-col gap-3">
            {timelineCases.map((tc) => (
              <button
                key={tc.id}
                onClick={() => setActive(tc)}
                className={`cursor-pointer text-left rounded-2xl border p-5 transition-all ${
                  active.id === tc.id
                    ? "border-primary-300 bg-background-50 shadow-sm"
                    : "border-transparent bg-background-100 hover:bg-background-50"
                }`}
              >
                <div className="flex items-center gap-2">
                  <span className="rounded-md bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">{tc.hot}</span>
                  <span className="text-[11px] text-foreground-400">{tc.status}</span>
                </div>
                <h3 className={`mt-3 font-heading text-lg font-bold ${active.id === tc.id ? "text-primary-700" : "text-foreground-950"}`}>
                  {tc.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{tc.desc}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {tc.tags.map((t) => (
                    <span key={t} className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                      {t}
                    </span>
                  ))}
                </div>
              </button>
            ))}

            <div className="rounded-2xl bg-primary-500 p-5 text-background-50">
              <div className="flex items-center gap-3">
                <i className="ri-megaphone-line text-2xl"></i>
                <div>
                  <p className="font-heading text-base font-bold">想复盘的事件没找到？</p>
                  <p className="mt-1 text-xs text-background-100/90">告诉我们，编辑团队会尽快补档。</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-950">{active.name}</h3>
                <p className="mt-1 text-sm text-foreground-500">{active.desc}</p>
              </div>
              <div className="flex flex-wrap gap-1.5 shrink-0">
                {active.tags.map((t) => (
                  <span key={t} className="rounded-md bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                    {t}
                  </span>
                ))}
              </div>
            </div>

            <div className="relative mt-8 pl-2">
              <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-primary-200"></div>
              <div className="flex flex-col gap-6">
                {active.nodes.map((n, i) => (
                  <div key={n.title} className="relative flex gap-4">
                    <span className="relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50">
                      <span className="h-2 w-2 rounded-full bg-primary-500"></span>
                    </span>
                    <div className={i === active.nodes.length - 1 ? "" : "pb-1"}>
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">{n.date}</span>
                        <h4 className="font-heading text-[15px] font-bold text-foreground-950">{n.title}</h4>
                      </div>
                      <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{n.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3 border-t border-background-200 pt-5">
              <button className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600">
                查看完整档案 <i className="ri-arrow-right-line"></i>
              </button>
              <button className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100">
                分享这条时间线
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}